export const GRID_CELL_HEIGHT = 30;
export const GRID_CELL_VMARGIN = 8;
export const GRID_COLUMN_COUNT = 24;
export const REPEAT_DIR_VERTICAL = 'v';
export const REPEAT_DIR_HORIZONTAL = 'h';

export const DEFAULT_PANEL_SPAN = 4;
export const DEFAULT_ROW_HEIGHT = 250;
export const MIN_PANEL_HEIGHT = GRID_CELL_HEIGHT * 3;

export const LS_PANEL_COPY_KEY = 'panel-copy';
export const LS_STYLES_COPY_KEY = 'styles-copy';
export const LS_ROW_COPY_KEY = 'row-copy';
export const LS_TAB_COPY_KEY = 'tab-copy';
export const PANEL_BORDER = 2;

export const DEFAULT_PER_PAGE_PAGINATION = 40;

export const LS_VISUALIZATION_SELECT_TAB_KEY = 'VisualizationSelectPane.ListMode';
export const MEGA_MENU_TOGGLE_ID = 'mega-menu-toggle';

/**
 * grafana-setupguide-app plugin ID, used in extension points to provide Cloud-only UI functionality.
 */
export const SETUPGUIDE_PLUGIN_ID = 'grafana-setupguide-app';

/**
 * grafana-assistant-app plugin ID, used in extension points to provide Assistant-only UI functionality.
 */
export const ASSISTANT_PLUGIN_ID = 'grafana-assistant-app';
/** Where the Assistant serves Grafana Pages: one page per `${ASSISTANT_PAGES_PATH}/<id>`; the path itself lists them. */
export const ASSISTANT_PAGES_PATH = `/a/${ASSISTANT_PLUGIN_ID}/pages`;
